import React from "react";
import { Segmented } from "antd";
import classNames from "classnames";

const CustomTabs = ({
    tabs = [],
    activeTab,
    onChange,
    className = "",
    height = "h-12",
    ...rest
}) => {
    const options = tabs.map((tab) => ({
        label: (
            <div className="flex items-center justify-center gap-1.5">
                {tab.icon &&
                    React.cloneElement(tab.icon, { className: "w-4 h-4" })}
                <span >{tab.label}</span>
            </div>
        ),
        value: tab.value,
    }));

    return (
        <Segmented
            {...rest}
            block
            options={options}
            value={activeTab}
            onChange={onChange}
            className={classNames(
                "bg-gray-100 font-medium text-slate-900 rounded-2xl",
                height,
                className,
                "custom-segmented"
            )}
        />
    );
};

export default CustomTabs;
